import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import { Input } from 'semantic-ui-react';

import CommonErrorIcon
  from 'components/common/CommonErrorIcon';
import CommonMessage from 'components/common/CommonMessage';

import './HighLightsDetailsInput.css';

const ENTER_KEY = 13;

class HighLightsDetailsInput extends Component {
  static propTypes = {
    addHighlightsDetail: PropTypes.func.isRequired,
    patchHighlightsDetail: PropTypes.func.isRequired,
    deleteHighlightsDetail: PropTypes.func.isRequired,
    initValue: PropTypes.string,
    patchError: PropTypes.object,
    additional: PropTypes.bool,
    id: PropTypes.number,
    actionsErrors: PropTypes.object,
    label: PropTypes.string.isRequired,
  };

  static defaultProps = {
    initValue: null,
    patchUserError: null,
    additional: null,
    id: null,
    actionsErrors: null,
  };

  state = {
    initialValue: '',
    currentValue: '',
    invalid: false,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);
    if (this.props.initValue) {
      this.setState({
        initialValue: this.props.initValue,
        currentValue: this.props.initValue,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue !== this.state.currentValue) {
      this.setState({ invalid: false });
    }

    if (prevProps.initValue !== this.props.initValue) {
      this.setState({ currentValue: this.props.initValue });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  executeValidation = () => {
    if (!this.state.currentValue) {
      this.setState({
        invalid: i18n.t("This field should not be empty"),
      });
    }
    if (this.state.currentValue && this.state.currentValue.length > 255) {
      this.setState({
        invalid: i18n.t("Ensure this field has no more than 255 characters"),
      });
    }
  };

  onAdd = () => {
    if (!this.state.invalid) {
      this.props.addHighlightsDetail(this.state.currentValue.trim());
    }
  };

  onPatch = () => {
    this.setState({ initialValue: this.state.currentValue.trim() });

    if (!this.state.invalid) {
      this.props.patchHighlightsDetail(
        this.props.id,
        { content: this.state.currentValue },
      );
    }
  };

  onDelete = () => {
    this.props.deleteHighlightsDetail(this.props.id);
  };

  executeAction = () => {
    const { currentValue, initialValue } = this.state;
    if (currentValue !== initialValue) {
      this.executeValidation();
    }
    if (currentValue && currentValue !== initialValue) {
      if (this.props.additional) {
        this.onAdd();
      } else {
        this.onPatch();
      }
    }
  };

  onEnterClick = event => {
    if (event.keyCode === ENTER_KEY) {
      this.executeAction();
    }
  };

  render() {
    const { id, additional, actionsErrors, label } = this.props;
    const { invalid, currentValue } = this.state;

    return (
      <div className={`highlights-details-input__component${invalid ? ' error' : ''}`}>
        <div className="input-wrapper">
          <Input
            value={currentValue}
            placeholder="Ex: Webby Award Winner"
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentValue: e.target.value });
            }}
            onBlur={() => { this.executeAction(); }}
          />

          {invalid &&
            <CommonErrorIcon
              key={`${id ? id : 'additional'}-error-key`}
              errorId={`${id ? id : 'additional'}-error-id`}
              errorText={invalid}
            />
          }

          {!additional &&
            <div
              className="remove-icon"
              onClick={this.onDelete}
              role="button"
              tabIndex={-1}
            />
          }

        </div>

        <div className="divider" />
        <div className="label">{label}</div>

        {actionsErrors &&
          <CommonMessage
            error
            errors={actionsErrors.content && actionsErrors.content}
            content={actionsErrors.detail && actionsErrors.detail}
          />
        }

      </div>
    );
  }
}

export default HighLightsDetailsInput;
